class InfiniteScroll {
    constructor(classname, fetch) {
        this.fetch = fetch;
        this.contents = document.querySelectorAll('.' + classname);
        this.loading = new Map();  // Track loading state for each div
        this.lastScrollTop = new Map();  // Store last scroll position for speed calculation

        // Thresholds and other configurable values
        this.distanceFromBottomThreshold = 400;
        this.scrollSpeedThreshold = 400;
        this.fastScrollThreshold = 800;

        //this.header = document.querySelector('.header'); 
        this.headerShrinkThreshold = 20; // Pixels scrolled down to trigger shrink
        this.headerExpandThreshold = 20; // Pixels scrolled up to trigger expand
        this.lastHeaderState = 'expanded'; // Track the last state of the header

        this.init();
    }

    init() {
        this.contents.forEach(content => {
            // Initialize loading state and last scroll position for this content
            this.loading.set(content.id, false);
            this.lastScrollTop.set(content.id, content.scrollTop);
            
            // Attach scroll listener
            content.addEventListener('scroll', this.throttle(this.onScroll.bind(this, content), 100));
        });
    }

    onScroll(content) {
        
        const currentScrollTop = content.scrollTop;
        const isScrollingDown = currentScrollTop > this.lastScrollTop.get(content.id);
        
        const scrollSpeed = Math.abs(currentScrollTop - this.lastScrollTop.get(content.id));
        this.lastScrollTop.set(content.id, currentScrollTop);


        this.handleHeaderSize(isScrollingDown, scrollSpeed, content);

        if (this.loading.get(content.id) || !isScrollingDown) {
            return;
        }

        const remainingDistanceToBottom = content.scrollHeight - (content.scrollTop + content.offsetHeight);
        
        const dynamicThreshold = scrollSpeed > this.scrollSpeedThreshold 
            ? this.fastScrollThreshold 
            : this.distanceFromBottomThreshold;

        if (remainingDistanceToBottom < dynamicThreshold) {
            this.fetchData(content.id);
        }
        
    }

    fetchData(contentId) {
        // Set loading state for this content
        this.loading.set(contentId, true);
        if(this.fetch) this.fetch(contentId);

        // Display a loading indicator (you can customize this)
        /*
        const contentDiv = document.getElementById(contentId);
        const loadingElement = document.createElement('div');
        loadingElement.innerText = 'Loading...';
        contentDiv.appendChild(loadingElement);
        */

        setTimeout(() => {
            console.log("Fetched data for:", contentId);

            // Remove loading indicator
            //contentDiv.removeChild(loadingElement);

            // Reset loading state
            setTimeout(() => {this.loading.set(contentId, false);},250);
        }, 800);
    }

    throttle(func, limit) {
        let inThrottle;
        return function() {
            const args = arguments;
            const context = this;
            if (!inThrottle) {
                func.apply(context, args);
                inThrottle = true;
                setTimeout(() => inThrottle = false, limit);
            }
        }
    }

    handleHeaderSize(isScrollingDown, scrollSpeed, content) {
        if (content.scrollTop < 1 && this.lastHeaderState !== 'expanded') {
            this.headerExpand();
            this.lastHeaderState = 'expanded';
        } else if (content.scrollTop >= 1 && this.lastHeaderState !== 'shrunk') {
            this.headerShrink();
            this.lastHeaderState = 'shrunk';
        } else if (content.scrollTop >= 1 && this.lastHeaderState === 'shrunk') {
            //not the best solution, yet it resolve fast scrolling issue and incorrect isScrollingDown values
            // console.log(isScrollingDown, 'expanded');
            setTimeout(() => {
                if (content.scrollTop < 1 && this.lastHeaderState !== 'expanded'/*&& not expanded logic*/) {
                    this.headerExpand();
                    this.lastHeaderState = 'expanded';
                }
            }, 300)
        }
    }
    

    headerShrink() {
        // Logic to shrink the header
        console.log("Header shrunk");
        document.querySelector('.bottom-row').classList.add('fadeOut');
        if (( window.innerWidth <= 700 )) {
            document.querySelector('.nav-cover').classList.add('fadeOut');
            document.querySelector('.nav-cover').classList.add('animate');
        }

    }

    headerExpand() {
        // Logic to expand the header
        console.log("Header expanded");
        document.querySelector('.bottom-row').classList.remove('fadeOut');
        if (( window.innerWidth <= 700 )) {
            document.querySelector('.nav-cover').classList.remove('fadeOut');
            document.querySelector('.nav-cover').classList.remove('animate');
        }
    }
}

module.exports = InfiniteScroll;